import * as React from 'react';
export const IcPersonalTrainer = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.5 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-9 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.18 6.58l-1.54-1 .53-2.11 2.88 1.44a1 1 0 10.9-1.78l-4-2-4-2a1 1 0 00-.9 1.78l3.29 1.63-.77 3.05-3.9 5.86a1 1 0 00.28 1.38A.94.94 0 003 20a1 1 0 00.83-.45l3.45-5.16 1.29.86L6.2 18.4a1 1 0 001.6 1.2l2.37-3.15a1.999 1.999 0 00-.49-2.87zm11.77-3.47l-4-2-4-2a1 1 0 00-.9 1.78l3.29 1.65-.77 3.05-3.9 5.86a1 1 0 00.28 1.38.94.94 0 00.55.17 1 1 0 00.83-.45l3.45-5.16 1.29.86-2.37 3.15a1 1 0 101.6 1.2l2.37-3.15a1.999 1.999 0 00-.49-2.87l-1.54-1 .53-2.11 2.88 1.44a1 1 0 00.9-1.78v-.02z'
      fill='currentColor'
    />
  </svg>
);
